import AddDistributionGroupMember from './Add-DistributionGroupMember';
import MailboxLocation from './Add-MailboxLocation';
import MailboxPermission from './Add-MailboxPermission';
import RecipientPermission from './Add-RecipientPermission';
import UnifiedGroupLinks from './Add-UnifiedGroupLinks';
import EnableAddressListPaging from './Enable-AddressListPaging';
import EnableMailbox from './Enable-Mailbox';
import EnableTransportRule from './Enable-TransportRule';
import RemoveInboxRule from './Remove-InboxRule';
import NewInboxRule from './New-InboxRule';
import NewTransportRule from './New-TransportRule';
import SetInboxRule from './Set-InboxRule';
import SetCASMailbox from './Set-CASMailbox';
import SetMailbox from './Set-Mailbox';

const operations: { [key: string]: any } = {
    'Add-DistributionGroupMember': AddDistributionGroupMember,
    'Add-MailboxLocation': MailboxLocation,
    'Add-MailboxPermission': MailboxPermission,
    'Add-RecipientPermission': RecipientPermission,
    'Add-UnifiedGroupLinks': UnifiedGroupLinks,
    'Enable-AddressListPaging': EnableAddressListPaging,
    'Enable-Mailbox': EnableMailbox,
    'Enable-TransportRule': EnableTransportRule,
    'Remove-InboxRule': RemoveInboxRule,
    'New-InboxRule': NewInboxRule,
    'New-TransportRule': NewTransportRule,
    'Set-InboxRule': SetInboxRule,
    'Set-CASMailbox': SetCASMailbox,
    'Set-Mailbox': SetMailbox,
};

export default operations;
